// 1. Imports React
// (Aucun import React nécessaire ici)

// 2. Imports externes
import {
  Building2,
  Calendar,
  CircleCheckBig,
  CircleSlash2,
  Hash,
  Mail,
  MapPin,
  Phone,
} from "lucide-react";

// 3. Imports composants UI
import { Badge } from "./ui/badge";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

// 4. Imports types
import type { Company } from "@/types/company.type";

// 5. Props
interface CompanyInfosProps {
  company: Company;
}

// 6. Composant
export const CompanyInfos = ({ company }: CompanyInfosProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Nom de l'entreprise */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-muted-foreground flex items-center gap-2">
          <Building2 className="h-4 w-4" />
          Nom de l'entreprise
        </label>
        <div className="p-3  border-b-2 ">
          <p className="text-sm font-medium">{company?.name || "-"}</p>
        </div>
      </div>

      {/* Email */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-muted-foreground flex items-center gap-2">
          <Mail className="h-4 w-4" />
          Email
        </label>
        <div className="p-3  border-b-2 ">
          <p className="text-sm font-medium">{company?.email || "-"}</p>
        </div>
      </div>

      {/* SIRET */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-muted-foreground flex items-center gap-2">
          <Hash className="h-4 w-4" />
          SIRET
        </label>
        <div className="p-3  border-b-2 ">
          <p className="text-sm font-mono font-medium">
            {company?.siret || "-"}
          </p>
        </div>
      </div>

      {/* Statut */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-muted-foreground flex items-center gap-2">
          <Building2 className="h-4 w-4" />
          Statut
        </label>
        <div className="p-3  border-b-2 ">
          <Badge
            variant={company?.isActive ? "default" : "secondary"}
            className={
              company?.isActive
                ? "bg-success hover:bg-success"
                : "bg-error hover:bg-error text-error-foreground"
            }
          >
            {company?.isActive ? (
              <>
                <CircleCheckBig className="h-3 w-3 mr-1" />
                Actif
              </>
            ) : (
              <>
                <CircleSlash2 className="h-3 w-3 mr-1" />
                Inactif
              </>
            )}
          </Badge>
        </div>
      </div>

      {/* Adresse */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-muted-foreground flex items-center gap-2">
          <MapPin className="h-4 w-4" />
          Adresse
        </label>
        <div className="p-3  border-b-2 ">
          <p className="text-sm font-medium">{company?.address || "-"}</p>
        </div>
      </div>

      {/* Code postal */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-muted-foreground flex items-center gap-2">
          <MapPin className="h-4 w-4" />
          Code postal
        </label>
        <div className="p-3  border-b-2 ">
          <p className="text-sm font-medium">{company?.postalCode || "-"}</p>
        </div>
      </div>

      {/* Ville */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-muted-foreground flex items-center gap-2">
          <MapPin className="h-4 w-4" />
          Ville
        </label>
        <div className="p-3  border-b-2 ">
          <p className="text-sm font-medium">{company?.city || "-"}</p>
        </div>
      </div>

      {/* Téléphone */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-muted-foreground flex items-center gap-2">
          <Phone className="h-4 w-4" />
          Téléphone
        </label>
        <div className="p-3  border-b-2 ">
          <p className="text-sm font-medium">{company?.phoneNumber || "-"}</p>
        </div>
      </div>

      {/* Date de création */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-muted-foreground flex items-center gap-2">
          <Calendar className="h-4 w-4" />
          Date de création
        </label>
        <div className="p-3  border-b-2 ">
          <p className="text-sm font-medium">
            {company?.createdAt
              ? format(new Date(company.createdAt), "PPP", { locale: fr })
              : "-"}
          </p>
        </div>
      </div>
    </div>
  );
};
